import { useAppDispatch } from "../../../../../store";
import { showCustomerProfile } from "../../../../../reducers/profile";

export const MAX_ORDERS = 5;

export const useOrderNavigation = () => {
  const dispatch = useAppDispatch();

  const handleOrderClick = (affAbo: string) => {
    dispatch(showCustomerProfile(affAbo));
  };

  return { handleOrderClick };
};
